import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { backUrl: String }

  connect() {
    this.changed = false
    this.element.addEventListener("input", this.#markChanged)
    this.element.addEventListener("change", this.#markChanged)
  }

  disconnect() {
    this.element.removeEventListener("input", this.#markChanged)
    this.element.removeEventListener("change", this.#markChanged)
  }

  leave(event) {
    if (this.changed && !confirm("入力中の内容が失われます。一覧に戻りますか？")) {
      event.preventDefault()
    }
  }

  #markChanged = () => {
    this.changed = true
  }
}
